import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { productsJsmConfigurationRoute } from '@atlassian/jira-router-routes-products-jsm-configuration-routes/src/productsJsmConfigurationRoute.tsx';
import ProductsJsmConfiguration, { LazyProductsJsmConfiguration } from './ui/index.tsx';

export const productsJsmConfigurationRouteEntry = createEntry(
	productsJsmConfigurationRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-configuration',
		component: ProductsJsmConfiguration,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		forPaint: [LazyAtlassianNavigation, LazyProductsJsmConfiguration],
	}),
);
